import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function TradeDeskIcon(props: IconProps) {
  return (
    <Icon fill="none" viewBox="0 0 19 21" {...props}>
      <Box as="path" fill="#0099FA" d="M11.028.12v11.25H7.954V3.236H4.762V.12h6.266Z" />
      <Box
        as="path"
        fill="#0099FA"
        d="M6.477 16.302v3.33C2.712 18.374 0 14.826 0 10.647A9.41 9.41 0 0 1 1.856 5.02h4.56v.002a6.402 6.402 0 0 0 .06 11.28Zm12.505-5.656c0 5.233-4.25 9.474-9.491 9.474a9.622 9.622 0 0 1-1.534-.124v-3.129c.491.12 1.005.184 1.534.184 3.543 0 6.418-2.867 6.418-6.405a6.405 6.405 0 0 0-3.344-5.625V1.683c3.732 1.274 6.417 4.804 6.417 8.963Z"
      />
    </Icon>
  );
}
